import type { Components, Theme } from '@mui/material';

export const listItemButtonCustomizations: Components<Theme> = {
  MuiListItemButton: {
    defaultProps: {
      disableRipple: true,
    },
  },
};
